import { styled } from '@mui/material/styles';

export const StyledButton = styled('button')(({ theme }) => ({
  width: '19rem',
  backgroundColor: theme.colors.base06,
  padding: '1.2rem auto',

  border: 0,
  borderRadius: '0.8rem',

  height: '4rem',

  cursor: 'pointer',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&:hover': {
    opacity: 0.8,
  },
}));

export const GradientTitle = styled('div')(({ theme }) => ({
  backgroundImage: theme.colors.gradient01,
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
}));

export const Base02Title = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));
